import { IconName } from '@fortawesome/fontawesome-svg-core';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AssetCategory as AssetCategoryType } from '../../models/generics';
import AppBadge from './AppBadge';

export const CATEGORY_ICONS: IconName[] = [
  'scroll', 'tools', 'user-secret', 'hand-sparkles', 'align-left',
  'magnifying-glass-chart', 'calculator', 'book'
];
type Props = {
  category?: AssetCategoryType;
  className?: string;
  solid?: boolean;
}

export default function AssetCategory({ className, category, solid: solidMode }: Props) {
  return (
    <AppBadge tooltip="Category" color={category?.hexColor || "#3044e1"} className={className} solid={solidMode}>
      <FontAwesomeIcon icon={category?.icon || solid('bookmark')} />
      <span className="ms-1">{category?.name}</span>
    </AppBadge>
  )
}